<template>
  <div class="inventoryDetail" style="margin-top: 0.49rem">
    <div class="inventoryDetail_menu">
      <van-dropdown-menu>
        <van-dropdown-item
          v-model="value1"
          :options="option"
          @change="changeIt(option[value1].text)"
        />
      </van-dropdown-menu>
    </div>
    <div class="selectMonth">
      <div style="width: 100%; height: 0.36rem; background: #f3f1f4">
        <div
          @click="toUp()"
          style="width: 1.2rem; height: 0.36rem; background: #f3f1f4"
        >
          <van-dropdown-menu :overlay="false">
            <van-dropdown-item :title="this.selectTime" />
          </van-dropdown-menu>
        </div>
      </div>
      <!-- 时间选择器 -->
      <van-action-sheet v-model="show">
        <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          title="选择年月"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          @confirm="toConfirm()"
          @cancel="toCancel()"
        />
      </van-action-sheet>
    </div>
    <div class="InventoryDetail_body">
      <van-list
        class="ul"
        :style="{ background: finished ? 'none' : '#ffffff' }"
        v-model="loading"
        :finished="finished"
        @load="onLoad"
      >
        <div class="InventoryDetail_body_list" v-for="item in InventoryDetail" :key="item.id">
          <div class="InventoryDetail_body_list_content">
            <div class="content_middle" style="margin-bottom: 0.08rem">
              <h2
                style="
                  font-size: 0.16rem;
                  font-weight: bold;
                  color: #333333;
                  margin-bottom: 0.08rem;
                "
              >
                {{ item.title }}
              </h2>

              <p style="font-size: 0.18rem; color: #319f06">
                <span v-show="item.money >= 0">+{{ item.money }}</span
                ><span v-show="item.money < 0" style="color: #ff5d5d">{{
                  item.money
                }}</span>
              </p>
            </div>
            <div class="content_bottom">
              <p style="font-size: 0.12rem; color: #999a9c">
                {{ item.ctime }}
              </p>
              <p
                style="
                  font-size: 0.12rem;
                  color: #333333;
                  line-height: 0.2rem;
                  height: 0.2rem;
                "
              >
                剩余库存：{{ item.surplus }}
              </p>
            </div>
          </div>
          <div class="line"></div>
        </div>
      </van-list>
      <!-- 当没有库存明细时 -->
      <div
        v-if="isNone"
        class="noOrder"
        style="
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          background: #f3f1f4;
        "
      >
        <img
          src="../../assets/img/empty/img_blank_content@2x.png"
          alt=""
          style="width: 2.17rem; height: 1.75rem; margin-top: 1.16rem"
        />
        <p
          style="
            height: 0.24rem;
            font-size: 0.12rem;
            color: #99999b;
            line-height: 0.24rem;
          "
        >
          您还没有库存明细哦~
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { getInventoryDetail } from "../../api/home.js";
export default {
  data() {
    return {
      value1: 0,
      switch1: false,
      selectTime: "", // 初始日期
      show: false, // 下面的弹框
      type: "", // 选择的类型
      option: [
        {
          text: "全部交易类型",
          value: 0,
        },
        {
          text: "补仓",
          value: 1,
        },
        {
          text: "销售",
          value: 2,
        },
        {
          text: "入库",
          value: 3,
        },
        {
          text: "配货",
          value: 4,
        },
        {
          text: "提货",
          value: 5,
        },
      ],
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      isTime: false,
      InventoryDetail: [],
      isNone: false,
      finished: false,
    };
  },
  created() {
    var date = new Date();
    this.selectTime = date.getFullYear() + "-" + (date.getMonth() + 1);
    this.onLoad();
  },
  methods: {
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    toUp() {
      this.show = true;
    },
    // 点击时间选择器上的确定
    toConfirm(value2) {
      this.page = 1;
      this.InventoryDetail = [];
      const year = this.currentDate.getFullYear();
      let month = this.currentDate.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      } else {
        month = month;
      }
      this.selectTime = year + "-" + month;
      this.show = false;
      getInventoryDetail({
        page: this.page,
        types: this.type,
        date: this.selectTime,
      })
        .then((res) => {
          this.InventoryDetail.push(...res.data.backdata.lists);
          this.page += 1;
          this.loading = false;
          if (res.data.backdata.lists == 0) {
            this.isNone = true;
          } else {
            this.isNone = false;
          }
          if (this.InventoryDetail.length >= res.data.ext.total) {
            this.finished = true;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 点击事件选择器上的取消
    toCancel() {
      this.show = false;
    },
    onLoad() {
      this.loading = true;
      getInventoryDetail({
        page: this.page,
        types: this.type,
        date: this.selectTime,
      })
        .then((res) => {
          // console.log(res);
          this.InventoryDetail.push(...res.data.backdata.lists);
          this.page += 1;
          this.loading = false;
          if (res.data.backdata.lists == 0) {
            this.isNone = true;
          } else {
            this.isNone = false;
          }
          if (this.InventoryDetail.length >= res.data.ext.total) {
            this.finished = true;
          }
          // console.log(this.InventoryDetail);
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    changeIt(val) {
      if (val == "全部交易类型") {
        val = "";
      }
      this.type = val;
      this.page = 1;
      this.InventoryDetail = [];
      getInventoryDetail({
        page: this.page,
        types: this.type,
        date: this.selectTime,
      })
        .then((res) => {
          this.InventoryDetail.push(...res.data.backdata.lists);
          this.page += 1;
          this.loading = false;
          if (res.data.backdata.lists == 0) {
            this.isNone = true;
          } else {
            this.isNone = false;
          }
          if (this.InventoryDetail.length >= res.data.ext.total) {
            this.finished = true;
          }
          // console.log(this.InventoryDetail);
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang='scss'>
.inventoryDetail {
  .inventoryDetail_menu {
    .van-dropdown-menu__bar {
      height: 0.44rem;

      .van-dropdown-menu__item {
        margin: 0 2.62rem 0 0rem;

        .van-dropdown-menu__title {
          padding: 0 0.06rem 0 0.12rem;
          font-size: 0.14rem;
          color: #333333;
          line-height: 0.2rem;
          height: 0.2rem;
        }
      }
    }
  }

  .selectMonth {
    .van-dropdown-menu__bar {
      height: 0.36rem;
      background: #f3f1f4;

      .van-dropdown-menu__item {
        .van-dropdown-menu__title {
          padding: 0 0.06rem 0 0.12rem;
          font-size: 0.14rem;
          color: #333333;
          line-height: 0.2rem;
          height: 0.2rem;
        }
      }
    }

    .van-dropdown-menu {
      .van-dropdown-menu__bar {
        box-shadow: none;
      }

      .van-dropdown-item--down {
        .van-dropdown-item__content {
          .van-dropdown-item__option--active {
            display: none;
          }
        }
      }
    }
  }

  /* 中间的列表 */
  .InventoryDetail_body {
    .InventoryDetail_body_list {
      padding-left: 0.15rem;
      background: #ffffff;

      .InventoryDetail_body_list_content {
        width: 100%;
        height: 0.93rem;
        background: #ffffff;
        padding: 0.2rem 0.15rem 0 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .content_middle {
          display: flex;
          justify-content: space-between;
        }

        .content_bottom {
          display: flex;
          justify-content: space-between;
          margin-bottom: 0.22rem;
        }
      }

      .line {
        width: 3.6rem;
        height: 0.01rem;
        background: #f3f1f4;
      }
    }
  }
}
</style>
